// チャットメッセージ削除履歴の型定義

// ルームタイプの定義
export const ROOM_TYPES: Record<string, string> = {
  'TalkRoom': '対話',
  'AdminTalkRoom': '運営相談',
  'SeniorTalkRoom': '上席相談'
};

export const getRoomTypeLabel = (roomType: string): string => {
  return ROOM_TYPES[roomType] || roomType;
};

// ユーザー情報の型
export interface UserInfo {
  id: number;
  name: string;
  nickname: string;
  user_type: string;
}

// チャットメッセージ削除履歴の型
export interface ChatMessageDeletionHistory {
  id: number;
  room_id: number;
  room_type: string;
  message: string;
  message_id: string;
  send_user_type: string;
  send_user_uid: string;
  chatroom_id: string;
  parent_uid: string | null;
  parent_user_type: string | null;
  child_uid: string | null;
  child_user_type: string | null;
  sent_at: string;
  deleted_at: string | null;
  deleted_by_uid: string | null;
  deleted_user_type: string | null;
  restored_at: string | null;
  restored_by_uid: string | null;
  restored_user_type: string | null;
  created_at: string;
  updated_at: string;
  // バックエンドから返されるユーザー情報
  parent_user: UserInfo | null;
  child_user: UserInfo | null;
  deleted_user: UserInfo | null;
  restored_user: UserInfo | null;
}

// ページネーションレスポンスの型
export interface ChatMessageDeletionHistoryListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: ChatMessageDeletionHistory[];
}

// 検索パラメータの型
export interface ChatMessageDeletionHistorySearchParams {
  page?: number;
  page_size?: number;
  room_id?: number;
  room_type?: string | string[];
  room_type__in?: string;  // Django-filter用の複数選択パラメータ
  send_user_type?: string;
  send_user_uid?: string;
  search?: string;        // Django REST Framework SearchFilterパラメータ (全ての検索フィールドに対して検索)
  message_search?: string; // 廃止予定
  sent_at_from?: string;
  sent_at_to?: string;
  deleted_at_from?: string;
  deleted_at_to?: string;
  restored_at_from?: string;
  restored_at_to?: string;
  is_deleted?: boolean;
  is_restored?: boolean;
}